export default __webpack_public_path__ + "static/media/intro-img-3928.8f4f4f59.png";